import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { QuickLinksService, QuickLink } from '../../../services/quick-links.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-quick-links-floating',
  templateUrl: './quick-links-floating.component.html',
  styleUrls: ['./quick-links-floating.component.scss']
})
export class QuickLinksFloatingComponent implements OnInit, OnDestroy {
  quickLinks: QuickLink[] = [];
  showQuickLinks = false;
  isAuthenticated = false;
  private quickLinksSubscription: Subscription;
  private showQuickLinksSubscription: Subscription;
  private routerSubscription: Subscription;

  constructor(
    private quickLinksService: QuickLinksService,
    private router: Router
  ) { }

  ngOnInit(): void {
    // Check authentication status initially
    this.checkAuthenticationStatus();

    // Subscribe to router events to check authentication on route changes
    this.routerSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.checkAuthenticationStatus();
    });

    this.quickLinksSubscription = this.quickLinksService.quickLinks$.subscribe(
      quickLinks => this.quickLinks = quickLinks
    );

    this.showQuickLinksSubscription = this.quickLinksService.showQuickLinks$.subscribe(
      show => this.showQuickLinks = show
    );
  }

  ngOnDestroy(): void {
    if (this.quickLinksSubscription) {
      this.quickLinksSubscription.unsubscribe();
    }

    if (this.showQuickLinksSubscription) {
      this.showQuickLinksSubscription.unsubscribe();
    }

    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  private checkAuthenticationStatus(): void {
    // Check if user is authenticated by checking for token in localStorage
    const token = localStorage.getItem('token');
    const isAuthRoute = this.router.url.startsWith('/auth');

    // Show quick links only if user is authenticated and not on auth pages
    this.isAuthenticated = !!token && !isAuthRoute;
  }

  activateQuickLink(quickLink: QuickLink): void {
    this.quickLinksService.activateQuickLink(quickLink);
  }

  toggleQuickLinks(): void {
    this.quickLinksService.toggleQuickLinks();
  }

  getSubtitle(link: QuickLink): string | null {
    const subtitles = {
      'F1': 'Advanced property search',
      'F2': 'Manage rental agreements',
      'F3': 'Property management',
      'F4': 'View booking schedule',
      'F5': 'Available units list',
      'F6': 'Tenant billing & invoices',
      'F7': 'Tenant contact management',
      'F8': 'Utility bill management',
      '?': 'Toggle shortcuts panel'
    };
    return subtitles[link.key] || null;
  }
}
